/* Shared consent plumbing. Defined defensively: the object is published to
   window BEFORE the Shopify API is touched, so if that call throws the
   helper still exists and callers degrade instead of breaking. */
(function () {
  if (window.AborderConsent) return;

  /* Versioned on purpose. Anyone who answered an older banner - or an
     earlier build of this one - has no v2 key, so they are asked once on
     this one and then never again. */
  var STORE_KEY = 'aborder_cookie_choice_v2';
  var state = { ready: false, failed: false, queue: [] };

  function api() {
    try { return window.Shopify && window.Shopify.customerPrivacy; }
    catch (e) { return null; }
  }

  function flush() {
    var pending = state.queue.slice();
    state.queue.length = 0;
    pending.forEach(function (fn) { try { fn(); } catch (e) {} });
  }

  function whenReady(fn) {
    if (state.ready || state.failed) { fn(); return; }
    state.queue.push(fn);
  }

  function localChoice() {
    try { return window.localStorage.getItem(STORE_KEY); } catch (e) { return null; }
  }

  function remember(values) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify({
        preferences: !!values.preferences,
        analytics: !!values.analytics,
        marketing: !!values.marketing
      }));
    } catch (e) {}
  }

  /* Reads the saved answer. Older builds wrote a plain 'all'/'essential'
     string, so those are still understood. */
  function storedValues() {
    var raw = localChoice();
    if (!raw) return null;
    if (raw === 'all') return { preferences: true, analytics: true, marketing: true };
    if (raw === 'essential') return { preferences: false, analytics: false, marketing: false };
    try {
      var o = JSON.parse(raw);
      if (o && typeof o === 'object') {
        return { preferences: !!o.preferences, analytics: !!o.analytics, marketing: !!o.marketing };
      }
    } catch (e) {}
    return null;
  }

  /* A choice counts only once it has been made on THIS banner. A prior
     Shopify consent record is not enough - the point is that every visitor,
     new or returning, is asked once. Anything unreadable errs toward asking. */
  function hasChosen() {
    try {
      if (!window.localStorage) return false;
      return !!localChoice();
    } catch (e) {
      // Private browsing and the like: fall back to Shopify's record so we
      // are not asking the same person on every single page view.
      var cp = api();
      if (cp && typeof cp.currentVisitorConsent === 'function') {
        try {
          var c = cp.currentVisitorConsent() || {};
          var keys = ['analytics', 'marketing', 'preferences', 'sale_of_data'];
          for (var i = 0; i < keys.length; i++) {
            var v = c[keys[i]];
            if (v === 'yes' || v === 'no' || v === true || v === false) return true;
          }
        } catch (e2) {}
      }
      return false;
    }
  }

  function current() {
    var saved = storedValues() || { preferences: false, analytics: false, marketing: false };
    var cp = api();
    if (cp && typeof cp.currentVisitorConsent === 'function') {
      try {
        var c = cp.currentVisitorConsent() || {};
        var on = function (v) { return v === 'yes' || v === true; };
        var decided = function (v) {
          return v === 'yes' || v === true || v === 'no' || v === false;
        };
        /* Shopify only wins where it actually holds an answer. Outside a
           configured region - or with the API not recording - it hands back
           empty strings, and taking those literally is what switched the
           settings page back off after Accept all. */
        return {
          preferences: decided(c.preferences) ? on(c.preferences) : saved.preferences,
          analytics: decided(c.analytics) ? on(c.analytics) : saved.analytics,
          marketing: decided(c.marketing) ? on(c.marketing) : saved.marketing
        };
      } catch (e) {}
    }
    return saved;
  }

  /* Always records the choice locally first, so the visitor is never asked
     twice even if Shopify's API is unavailable. done(syncedToShopify). */
  function save(values, done) {
    remember(values);
    /* Tell anything already on screen - the settings page switches, say -
       so the bar and the page never disagree about what was chosen. */
    try {
      document.dispatchEvent(new CustomEvent('aborder:consent', { detail: values }));
    } catch (e) {}
    whenReady(function () {
      var cp = api();
      if (!cp || typeof cp.setTrackingConsent !== 'function') { if (done) done(false); return; }
      try {
        cp.setTrackingConsent(
          {
            preferences: values.preferences,
            analytics: values.analytics,
            marketing: values.marketing,
            // Ad pixels hand data to the ad platforms, so this follows the
            // advertising choice rather than being a switch of its own.
            sale_of_data: values.marketing
          },
          function () { if (done) done(true); }
        );
      } catch (e) { if (done) done(false); }
    });
  }

  window.AborderConsent = {
    whenReady: whenReady,
    hasChosen: hasChosen,
    current: current,
    save: save
  };

  // Only now go near Shopify's loader.
  try {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (error || !api()) state.failed = true;
          else state.ready = true;
          flush();
        }
      );
    } else {
      state.failed = true;
      flush();
    }
  } catch (e) {
    state.failed = true;
    flush();
  }

  window.setTimeout(function () {
    if (!state.ready && !state.failed) { state.failed = true; flush(); }
  }, 2500);
})();
